/* eslint-disable no-console */

class LoggableErrors {
  constructor() {
    this.pageUnloading = false;
    this.loggedCount = 0;
    if (window.addEventListener) {
      window.addEventListener('beforeunload', event => {
        this.pageUnloading = true;
      });
    }
  }

  loggable = payload => {
    return (
      this.isKareoJS(payload) &&
      !this.pageUnloading &&
      !this.ignoreError(payload)
    );
  };

  ignoreError(payload) {
    if (payload && payload.body && payload.body.exception) {
      var message = payload.body.exception.message;
      // ignore failed to load template errors
      // this occurs in firefox when navigating away from the page cancels the xhr requests
      if (
        message &&
        message.indexOf('Failed to load template') > -1 &&
        (message.indexOf('HTTP status: 0') > -1 ||
          message.indexOf('HTTP status: -1') > -1)
      ) {
        return true;
      }
    }
    return false;
  }

  isKareoJS(payload) {
    // return early and always allow logging from localhost and UI Proxy
    if (payload.environment === 'localhost') {
      return true;
    } else if (payload.environment === 'uiproxy') {
      return true;
    }
    if (
      !payload ||
      !payload.body ||
      !payload.body.trace ||
      !payload.body.trace.frames
    ) {
      // this is unexpected to reach this code
      // log for now and fix later
      return true;
    }
    var frames = payload.body.trace.frames;
    if (!frames || !frames.length) {
      // missing stack
      return true;
    }
    for (var i = 0; i < frames.length; i++) {
      // ignore legacy apps
      if (
        frames[i].filename &&
        frames[i].filename.indexOf('kareo.com') > 0 &&
        frames[i].filename.indexOf('-ui/') > 0
      ) {
        return true;
      }
    }
    return false;
  }

  translateMethodName(str) {
    if (str.indexOf('anonymous') >= 0 || str === 'callback') {
      str = 'anonymous';
    }
    var lastPeriod = str.lastIndexOf('.');
    if (lastPeriod) {
      str = str.substr(lastPeriod + 1);
    }
    return str;
  }

  translateFileName(filename) {
    if (filename === 'code' || filename === '<anonymous>') {
      return 'anonymous';
    }
    return filename;
  }

  tagBrowser(payload) {
    var userAgent = window.navigator.userAgent.toLowerCase();
    if (window.chrome) {
      payload.context = 'chrome';
    } else if (userAgent.indexOf('firefox') > -1) {
      payload.context = 'firefox';
    }
  }

  transformError = payload => {
    try {
      if (payload && payload.body && payload.body.trace) {
        var frames = payload.body.trace.frames;
        payload.methodNames = [];
        for (var i = 1; i < frames.length; i++) {
          var methodName = this.translateMethodName(frames[i].method);
          // remove frames from grouping if before $digest
          if (methodName.indexOf('$digest') >= 0) {
            payload.methodNames = [];
          }
          payload.methodNames.push(methodName);
          frames[i].filename = this.translateFileName(frames[i].filename);
        }
        payload.useStrippedMethodNames = 'use';
        this.tagBrowser(payload);
      }
    } catch (ex) {
      console.error('exception transforming error');
    }
  };

  checkIgnore = (isUncaught, args, payload) => {
    try {
      if (this.loggable(payload) && this.loggedCount < 2) {
        this.loggedCount++;
        return false;
      }
      if (!isUncaught) {
        console.error(args[0]);
      }
      return true;
    } catch (ex) {
      console.log(ex);
      return false;
    }
  };
}

export default LoggableErrors;
